import { Textarea as TA, TextareaProps } from '@mantine/core'

export default function TextArea({ ...props }: TextareaProps) {
  return (
    <TA
      {...props}
      autosize
      styles={{
        label: {
          fontFamily: 'Plus Jakarta Sans',
          color: '#111928',
          fontSize: '1em',
        },
        input: {
          backgroundColor: '#F9FAFB',
          height: '3em',
          borderRadius: '0.7em',
          color: '#6B7280',
          borderWidth: '1px',
          borderColor: '#D1D5DB',
          fontSize: '1em',
          fontFamily: 'Plus Jakarta Sans',
          minHeight: '140px',
        },
      }}
    />
  )
}
